"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CampaignDetailBody = exports.default = void 0;

var _ObjectDetailNew2 = babelHelpers.interopRequireWildcard(require("layouts/ObjectDetailNew"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _react = babelHelpers.interopRequireDefault(require("react"));

var _decorators = require("decorators");

var _InfoBar = require("campaign/InfoBar");

var CampaignDetail =
/*#__PURE__*/
function (_ObjectDetailNew) {
  babelHelpers.inherits(CampaignDetail, _ObjectDetailNew);

  function CampaignDetail() {
    babelHelpers.classCallCheck(this, CampaignDetail);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(CampaignDetail).apply(this, arguments));
  }

  return CampaignDetail;
}(_ObjectDetailNew2.default);

exports.default = CampaignDetail;

var CampaignDetailBody =
/*#__PURE__*/
function (_ObjectDetailNewBody) {
  babelHelpers.inherits(CampaignDetailBody, _ObjectDetailNewBody);

  function CampaignDetailBody() {
    babelHelpers.classCallCheck(this, CampaignDetailBody);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(CampaignDetailBody).apply(this, arguments));
  }

  babelHelpers.createClass(CampaignDetailBody, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(CampaignDetailBody, this.props.content);
    }
  }]);
  return CampaignDetailBody;
}(_ObjectDetailNew2.ObjectDetailNewBody);

exports.CampaignDetailBody = CampaignDetailBody;